import { MicrocertificateModel } from '@/models/microcertificates/microcertificate.model';
import { MutationTree } from 'vuex';
import { MicrocertificateState } from './state';

const mutations: MutationTree<MicrocertificateState> = {
  SET_MICROCERTIFICATES(state, microcertificates: MicrocertificateModel[]) {
    state.microcertificates = microcertificates;
  },
  SET_GENERATING_MICROCERTIFICATE(state, generating: boolean) {
    state.isGenerating = generating;
  },
};

export default mutations;
